import makeSlug from "@/utils/makeSlug";
import { markets } from "@features/market/config/market-config";

export default function getLocaleFromPathname(pathname: string) {
  let localPathname = pathname.trim();
  if (!pathname.startsWith("/")) localPathname = makeSlug(localPathname);
  const parts = pathname.split("/");

  if (Object.values(markets).some((market) => market.siteLocale === parts[1])) {
    return parts[1];
  }

  return "";
}
